var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41 34",
    style: {
      enableBackground: "new 0 0 41 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF3D32;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    className: "st0",
    d: "M37.9,34H3.1c-0.6,0-1.1-0.3-1.4-0.8c-0.3-0.5-0.3-1.1,0-1.7L19.1,0.8C19.4,0.3,19.9,0,20.5,0 s1.1,0.3,1.4,0.8l17.4,30.7c0.3,0.5,0.3,1.1,0,1.7C39.1,33.7,38.5,34,37.9,34z M5.9,30.7h29.1L20.5,5L5.9,30.7z M22.2,20.8v-7.7 c0-0.9-0.7-1.7-1.7-1.7s-1.7,0.7-1.7,1.7v7.7c0,0.9,0.7,1.7,1.7,1.7S22.2,21.7,22.2,20.8z M22,27.7c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.5-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.5,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.5,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6C21,28.3,21.6,28,22,27.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.13842c2cb2fedb38f458f66e824968b2.svg";
export { ForwardRef as ReactComponent };